import React from 'react'
import { useContext } from '../Context'
import { PopUpContainer } from '../../../../components/header/quick-create/PopUpContainer'
import { MenuPopUpEnum } from '../MenuPopUpEnum'
import { AddAdjustment } from '../../../add-adjustment'

export const AdjustmentPopUp = () => {
  const { menuTarget, open, onCloseMenu } = useContext()

  return (
    <PopUpContainer show={menuTarget?.show === MenuPopUpEnum.adjustment && open} target={menuTarget?.target}>
      <AddAdjustment onCloseMenu={onCloseMenu} />
    </PopUpContainer>
  )
}
